import { Suspense } from 'react';
import { useRouterState } from '@tanstack/react-router';

import { checkDashboardAccess } from '@/lib/route-utils';
import Header from '@/components/layout/header/header-layout';
import Sidebar from '@/components/layout/nav/sidebar-layout';
import Content from '@/components/layout/content/content-layout';
import { DashboardLayoutProvider } from '@/stores/context/dashboard-layout-context';
import { useStore } from '@/stores';

// import { PopupAnnouncement } from '../shared/popup-announcement';

function DashboardLayout({ children }: { children: React.ReactNode }) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const roleAccess = useStore((state) => state.merchantAccess);
  const profile = useStore((state) => state.profile);
  const hasAccess = checkDashboardAccess(pathname, roleAccess);

  // const { shownPopupAnnountcement, setPopupAnnountcement } = useStore();

  return (
    <DashboardLayoutProvider>
      <div className="flex min-h-screen w-full">
        <Header />

        <div className="flex w-full flex-row gap-4 px-4 pt-[130px]">
          <Sidebar />
          <Suspense>
            <div className="flex min-h-screen w-full flex-1 flex-col pb-5 md:pl-[270px]">
              <Content
                statusRegistered={(profile && profile.business.status) || ''}
                isAccountGroup={profile?.is_group ?? undefined}
              >
                {hasAccess ? children : <div>No access</div>}
              </Content>
            </div>
          </Suspense>
        </div>
      </div>
      {/* USE FOR POPUP ANNOUNTCEMENT */}
      {/* <PopupAnnouncement
        opened={shownPopupAnnountcement}
        toggleModal={() => setPopupAnnountcement({ shownPopupAnnountcement: false })}
      /> */}
    </DashboardLayoutProvider>
  );
}

DashboardLayout.Header = Header;
DashboardLayout.Sidebar = Sidebar;
DashboardLayout.Content = Content;

export default DashboardLayout;
